import React, { useState } from 'react';

import {
    CardBody,
    CardTitle,
    Row,
    Col,
    Button,
    FormGroup,
    Label,
    Table
} from 'reactstrap';

import Parametri from '../../parametri';
import Clessidra from '../Clessidra.js';
import Modale from '../Modale.js';
import TendinaEditabile from '../TendinaEditabile.js';

const STATO_SELEZIONA_FILE = 0;
const STATO_VISUALIZZA_ANALISI = 1;

function ImportazioneMovimentiBancari(props) {

    const [statoPagina, setStatoPagina] = useState(STATO_SELEZIONA_FILE);
    const [contenutoFile, setContenutoFile] = useState(null);
    const [separatore, setSeparatore] = useState('auto');
    const [loading, setLoading] = useState(false);

    const [errore, setErrore] = useState('');
    const [messaggio, setMessaggio] = useState('');

    const [risultatoAnalisi, setRisultatoAnalisi] = useState(null);
    const [movimentiSelezionati, setMovimentiSelezionati] = useState({});

    const [risultatoServerDatiPersona, setRisultatoServerDatiPersona] = useState([]);
    const [classificazioniManuali, setClassificazioniManuali] = useState({});

    // Dopo una registrazione riuscita, anche parzialmente,
    // impedisce un secondo invio degli stessi movimenti.
    const [registrazioneEseguita, setRegistrazioneEseguita] = useState(false);


    // -------------------------------------------------------------------------------------------------------
    // Carica gli iscritti per la classificazione manuale dei bonifici.
    // -------------------------------------------------------------------------------------------------------
    function caricaIscritti() {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                op: 'elencoPersone',
                ridotto: 1,
                recordPartenza: 1,
                intervallo: '',
                emak: props.emak,
                sessionId: props.sessionId
            })
        };

        fetch(
            Parametri('serverURL', props.identitaSelezionata),
            requestOptions
        )
        .then(risposta => {

            if (!risposta.ok) {
                throw new Error('Errore HTTP ' + risposta.status);
            }

            return risposta.json();
        })
        .then(valoreDiRitorno => {

            if (valoreDiRitorno.risultatoOperazione === 2) {
                props.setPagina(props.PAGINE.tornaLogin);
                return;
            }

            if (valoreDiRitorno.risultatoOperazione === 1) {

                setRisultatoServerDatiPersona(
                    valoreDiRitorno.risultatoRitorno || []
                );

            } else {

                setErrore(
                    'Impossibile caricare l’elenco degli iscritti.'
                );
            }
        })
        .catch(error => {

            setErrore(
                'Errore caricando gli iscritti: ' + error.message
            );
        });
    }


    // -------------------------------------------------------------------------------------------------------
    // Associa manualmente un movimento a un iscritto.
    // -------------------------------------------------------------------------------------------------------
    function selezionaIscrittoMovimento(riga, valore, valoreNonVisibile) {

        const idpersona = Number(valoreNonVisibile);

        if (idpersona > 0) {

            setClassificazioniManuali(prev => ({
                ...prev,
                [riga]: {
                    tipoEntrata: 'quota_iscritto',
                    idpersona: idpersona,
                    nominativo: valore
                }
            }));

            setMovimentiSelezionati(prev => ({
                ...prev,
                [riga]: true
            }));

        } else {

            setClassificazioniManuali(prev => {
                const aggiornate = { ...prev };
                delete aggiornate[riga];
                return aggiornate;
            });

            setMovimentiSelezionati(prev => ({
                ...prev,
                [riga]: false
            }));
        }
    }


    // -------------------------------------------------------------------------------------------------------
    // Classifica manualmente un movimento come entrata generica.
    // -------------------------------------------------------------------------------------------------------
    function classificaEntrataGenerica(riga) {

        setClassificazioniManuali(prev => ({
            ...prev,
            [riga]: {
                tipoEntrata: 'generica'
            }
        }));

        setMovimentiSelezionati(prev => ({
            ...prev,
            [riga]: true
        }));
    }


    // -------------------------------------------------------------------------------------------------------
    // Annulla la classificazione manuale.
    // -------------------------------------------------------------------------------------------------------
    function annullaClassificazione(riga) {

        setClassificazioniManuali(prev => {
            const aggiornate = { ...prev };
            delete aggiornate[riga];
            return aggiornate;
        });

        setMovimentiSelezionati(prev => ({
            ...prev,
            [riga]: false
        }));
    }


    // -------------------------------------------------------------------------------------------------------
    // Restituisce il tipo di entrata effettivo, considerando le modifiche manuali.
    // -------------------------------------------------------------------------------------------------------
    function tipoEntrataEffettivo(movimento) {

        const classificazione = classificazioniManuali[movimento.riga];

        if (classificazione && classificazione.tipoEntrata) {
            return classificazione.tipoEntrata;
        }

        return movimento.tipoEntrata;
    }


    // -------------------------------------------------------------------------------------------------------
    // Indica se un movimento può essere selezionato per la registrazione.
    // -------------------------------------------------------------------------------------------------------
    function movimentoImportabile(movimento) {

        if (registrazioneEseguita) {
            return false;
        }

        if (
            movimento.importoCentesimi > 0 &&
            tipoEntrataEffettivo(movimento) === 'da_identificare'
        ) {
            return false;
        }

        return true;
    }


    // -------------------------------------------------------------------------------------------------------
    // Analizza il file CSV.
    // -------------------------------------------------------------------------------------------------------
    function analizzaFile() {

        if (!contenutoFile) {
            setErrore('Selezionare un file CSV da analizzare.');
            return;
        }

        const formData = new FormData();

        formData.append('op', 'importazioneMovimentiBancari');
        formData.append('operazione', 'analizza');
        formData.append('contenutoFile', contenutoFile);
        formData.append('separatore', separatore);
        formData.append('emak', props.emak);
        formData.append('session_id', props.sessionId);

        setLoading(true);
        setErrore('');
        setMessaggio('');

        fetch(
            Parametri('serverURL', props.identitaSelezionata),
            {
                method: 'POST',
                body: formData
            }
        )
        .then(risposta => {

            if (!risposta.ok) {
                throw new Error('Errore HTTP ' + risposta.status);
            }

            return risposta.json();
        })
        .then(valoreDiRitorno => {

            setLoading(false);

            if (valoreDiRitorno.risultatoOperazione === 2) {
                props.setPagina(props.PAGINE.tornaLogin);
                return;
            }

            if (valoreDiRitorno.risultatoOperazione !== 1) {

                setErrore(
                    valoreDiRitorno.mess ||
                    'Errore durante l’analisi del file bancario.'
                );

                return;
            }

            if (!Array.isArray(valoreDiRitorno.movimenti)) {

                setErrore(
                    'La risposta del server non contiene un elenco di movimenti valido.'
                );

                return;
            }

            const selezioni = {};

            valoreDiRitorno.movimenti.forEach(movimento => {

                selezioni[movimento.riga] =
                    movimento.possibileDuplicato === false &&
                    movimento.tipoEntrata !== 'da_identificare';
            });

            setMovimentiSelezionati(selezioni);
            setClassificazioniManuali({});
            setRisultatoAnalisi(valoreDiRitorno);
            setRegistrazioneEseguita(false);

            setStatoPagina(STATO_VISUALIZZA_ANALISI);

            // Carichiamo gli iscritti soltanto se esistono
            // entrate che richiedono una classificazione manuale.
            const presentiEntrateDaIdentificare =
                valoreDiRitorno.movimenti.some(
                    movimento =>
                        movimento.importoCentesimi > 0 &&
                        movimento.tipoEntrata === 'da_identificare'
                );

            if (presentiEntrateDaIdentificare) {
                caricaIscritti();
            }
        })
        .catch(error => {

            setLoading(false);

            setErrore(
                'Errore di connessione: ' + error.message
            );
        });
    }


    // -------------------------------------------------------------------------------------------------------
    // Nuova importazione.
    // -------------------------------------------------------------------------------------------------------
    function nuovaImportazione() {

        setContenutoFile(null);
        setRisultatoAnalisi(null);
        setMovimentiSelezionati({});
        setRisultatoServerDatiPersona([]);
        setClassificazioniManuali({});

        setRegistrazioneEseguita(false);

        setErrore('');
        setMessaggio('');

        setStatoPagina(STATO_SELEZIONA_FILE);
    }


    // -------------------------------------------------------------------------------------------------------
    // Registra in Prima Nota i movimenti selezionati.
    // -------------------------------------------------------------------------------------------------------
    function registraMovimenti() {

        if (loading || registrazioneEseguita) {
            return;
        }

        const selezionati = movimenti
            .filter(movimento =>
                !!movimentiSelezionati[movimento.riga] &&
                movimentoImportabile(movimento)
            )
            .map(movimento => ({
                ...movimento,
                ...(classificazioniManuali[movimento.riga] || {})
            }));

        if (selezionati.length === 0) {
            return;
        }

        const conferma = window.confirm(
            'Confermi la registrazione di ' +
            selezionati.length +
            ' movimenti in Prima Nota?\n\n' +
            'L’operazione genererà anche le ricevute per gli incassi delle quote.'
        );

        if (!conferma) {
            return;
        }

        const formData = new FormData();

        formData.append('op', 'importazioneMovimentiBancari');
        formData.append('operazione', 'registra');
        formData.append('movimenti', JSON.stringify(selezionati));
        formData.append('emak', props.emak);
        formData.append('session_id', props.sessionId);

        setLoading(true);
        setErrore('');
        setMessaggio('');

        fetch(
            Parametri('serverURL', props.identitaSelezionata),
            {
                method: 'POST',
                body: formData
            }
        )
        .then(risposta => {

            if (!risposta.ok) {
                throw new Error('Errore HTTP ' + risposta.status);
            }

            return risposta.json();
        })
        .then(valoreDiRitorno => {

            setLoading(false);

            if (valoreDiRitorno.risultatoOperazione === 2) {
                props.setPagina(props.PAGINE.tornaLogin);
                return;
            }

            if (valoreDiRitorno.risultatoOperazione !== 1) {

                setErrore(
                    valoreDiRitorno.mess ||
                    'Errore durante la registrazione.'
                );

                return;
            }

            const registrati = Number(valoreDiRitorno.registrati) || 0;
            const errori = valoreDiRitorno.errori || [];

            // Se almeno un movimento è stato registrato,
            // blocchiamo ulteriori invii di questa analisi.
            if (registrati > 0) {
                setRegistrazioneEseguita(true);
            }

            if (errori.length > 0) {

                const dettagliErrori = errori.map(
                    e => 'Riga ' + e.riga + ': ' + e.mess
                ).join('\n');

                setErrore(
                    'Movimenti registrati: ' + registrati +
                    '\nMovimenti non registrati: ' + errori.length +
                    '\n\n' +
                    dettagliErrori +
                    (
                        registrati > 0
                            ? '\n\nPer evitare doppie registrazioni, ' +
                              'questa importazione è stata bloccata. ' +
                              'Esegui una nuova analisi per riprovare.'
                            : ''
                    )
                );

            } else {

                setMessaggio(
                    'Registrazione completata correttamente.\n' +
                    'Movimenti registrati: ' + registrati
                );
            }
        })
        .catch(error => {

            setLoading(false);

            // Non sappiamo se il server abbia registrato qualcosa
            // prima che la connessione si interrompesse.
            // Impediamo quindi un secondo invio immediato.
            setRegistrazioneEseguita(true);

            setErrore(
                'Errore durante la comunicazione con il server: ' +
                error.message +
                '\n\nNon è possibile sapere se alcuni movimenti ' +
                'siano stati registrati. ' +
                'Esegui una nuova analisi prima di riprovare.'
            );
        });
    }


    // -------------------------------------------------------------------------------------------------------
    // Dati derivati dall'analisi.
    // -------------------------------------------------------------------------------------------------------
    const movimenti =
        risultatoAnalisi && Array.isArray(risultatoAnalisi.movimenti)
            ? risultatoAnalisi.movimenti
            : [];

    const entrate = movimenti.filter(
        movimento => movimento.importoCentesimi > 0
    );

    const uscite = movimenti.filter(
        movimento => movimento.importoCentesimi < 0
    );

    const riconosciuti = entrate.filter(
        movimento =>
            tipoEntrataEffettivo(movimento) === 'quota_iscritto'
    );

    const daIdentificare = entrate.filter(
        movimento =>
            tipoEntrataEffettivo(movimento) === 'da_identificare'
    );

    const generiche = entrate.filter(
        movimento =>
            tipoEntrataEffettivo(movimento) === 'generica'
    );

    const numeroSelezionati = movimenti.filter(
        movimento =>
            !!movimentiSelezionati[movimento.riga] &&
            movimentoImportabile(movimento)
    ).length;

    const numeroDuplicati = movimenti.filter(
        movimento => movimento.possibileDuplicato === true
    ).length;


    // -------------------------------------------------------------------------------------------------------
    // Visualizzazione.
    // -------------------------------------------------------------------------------------------------------
    return (

        <div
            className="schedaContenitore"
            style={{
                height: props.dimensioniApp.yMain,
                display: 'flex',
                flexDirection: 'column'
            }}
        >

            <Clessidra loading={loading}/>

            {errore !== '' &&
                <Modale
                    titolo="Importazione movimenti bancari"
                    flagErrore={true}
                    contenuto={
                        <div style={{whiteSpace: 'pre-wrap'}}>
                            {errore}
                        </div>
                    }
                    bottoni={[
                        {
                            etichetta: 'OK',
                            tipo: 'primary',
                            callback: () => setErrore('')
                        }
                    ]}
                />
            }

            {messaggio !== '' &&
                <Modale
                    titolo="Importazione movimenti bancari"
                    flagErrore={false}
                    contenuto={
                        <div style={{whiteSpace: 'pre-wrap'}}>
                            {messaggio}
                        </div>
                    }
                    bottoni={[
                        {
                            etichetta: 'OK',
                            tipo: 'primary',
                            callback: () => setMessaggio('')
                        }
                    ]}
                />
            }

            <div
                className="schedaSpazioCentrale"
                style={{
                    height: props.dimensioniApp.yMain,
                    overflowY: 'auto'
                }}
            >

                <CardBody>

                    <CardTitle>
                        Importazione movimenti bancari
                    </CardTitle>


                    {/* -------------------------------------------------------------------- */}
                    {/* SELEZIONE FILE */}
                    {/* -------------------------------------------------------------------- */}

                    {statoPagina === STATO_SELEZIONA_FILE &&
                        <>

                            <FormGroup>
                                <Label>
                                    <b>Separatore dei campi</b>
                                </Label>

                                <select
                                    className="inputStandard"
                                    value={separatore}
                                    onChange={e =>
                                        setSeparatore(e.target.value)
                                    }
                                >
                                    <option value="auto">
                                        Automatico
                                    </option>

                                    <option value=",">
                                        Virgola (,)
                                    </option>

                                    <option value=";">
                                        Punto e virgola (;)
                                    </option>
                                </select>
                            </FormGroup>

                            <FormGroup>

                                <Label>
                                    <b>
                                        <u>
                                            Clicca qui per selezionare
                                            il file bancario CSV
                                        </u>
                                    </b>
                                </Label>

                                <input
                                    type="file"
                                    style={{width: 700}}
                                    accept=".csv"
                                    onChange={e => {
                                        setContenutoFile(
                                            e.target.files[0] || null
                                        );
                                    }}
                                />

                            </FormGroup>

                            {contenutoFile &&
                                <p>
                                    File selezionato:{' '}
                                    <b>{contenutoFile.name}</b>
                                </p>
                            }

                            <Row>
                                <Col md={12}>

                                    <Button
                                        color="success"
                                        disabled={!contenutoFile || loading}
                                        onClick={analizzaFile}
                                    >
                                        Analizza file
                                    </Button>

                                </Col>
                            </Row>

                        </>
                    }


                    {/* -------------------------------------------------------------------- */}
                    {/* RISULTATO ANALISI */}
                    {/* -------------------------------------------------------------------- */}

                    {statoPagina === STATO_VISUALIZZA_ANALISI &&
                        <>

                            <p>
                                <b>Analisi completata.</b>
                                {' '}
                                Sono stati letti {movimenti.length} movimenti.
                            </p>

                            <p>
                                Entrate: <b>{entrate.length}</b>
                                {' | '}
                                Uscite: <b>{uscite.length}</b>
                                {' | '}
                                Quote iscritti: <b>{riconosciuti.length}</b>
                                {' | '}
                                Entrate da identificare: <b>{daIdentificare.length}</b>
                                {' | '}
                                Entrate generiche: <b>{generiche.length}</b>
                            </p>

                            <div>
                                Movimenti selezionati:{' '}
                                <b>{numeroSelezionati}</b>
                                {' | '}
                                Possibili duplicati:{' '}
                                <b>{numeroDuplicati}</b>
                            </div>

                            {registrazioneEseguita &&
                                <div
                                    className="alert alert-info"
                                    style={{marginTop: 15}}
                                >
                                    Registrazione già eseguita o inviata.
                                    Per effettuare un'altra importazione,
                                    esegui una nuova analisi.
                                </div>
                            }

                            <br/>


                            {/* ------------------------------------------------------------ */}
                            {/* TABELLA MOVIMENTI */}
                            {/* ------------------------------------------------------------ */}

                            <Table responsive striped bordered size="sm">

                                <thead>
                                    <tr>
                                        <th>Importa</th>
                                        <th>Stato</th>
                                        <th>Data</th>
                                        <th>Descrizione</th>

                                        <th style={{textAlign: 'right'}}>
                                            Importo
                                        </th>

                                        <th>Categoria</th>
                                        <th>Iscritto / classificazione</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {movimenti.map(movimento => {

                                        const tipoEntrata =
                                            tipoEntrataEffettivo(movimento);

                                        const classificazione =
                                            classificazioniManuali[movimento.riga];

                                        const importabile =
                                            movimentoImportabile(movimento);

                                        return (

                                            <tr
                                                key={movimento.riga}
                                                style={{
                                                    backgroundColor:
                                                        movimento.possibileDuplicato
                                                            ? '#fff3cd'
                                                            : undefined
                                                }}
                                            >

                                                {/* Checkbox */}
                                                <td>

                                                    <input
                                                        type="checkbox"
                                                        disabled={
                                                            !importabile || loading
                                                        }
                                                        checked={
                                                            importabile &&
                                                            !!movimentiSelezionati[movimento.riga]
                                                        }
                                                        onChange={e => {

                                                            setMovimentiSelezionati(
                                                                prev => ({
                                                                    ...prev,
                                                                    [movimento.riga]:
                                                                        e.target.checked
                                                                })
                                                            );

                                                        }}
                                                    />

                                                </td>


                                                {/* Duplicati */}
                                                <td>

                                                    {movimento.possibileDuplicato === true
                                                        ? 'Possibile duplicato'
                                                        : movimento.possibileDuplicato === null
                                                            ? 'Verifica duplicati non riuscita'
                                                            : 'Nuovo'
                                                    }

                                                </td>


                                                {/* Data */}
                                                <td>
                                                    {movimento.data}
                                                </td>


                                                {/* Descrizione */}
                                                <td>
                                                    {movimento.descrizione}
                                                </td>


                                                {/* Importo */}
                                                <td style={{textAlign: 'right'}}>

                                                    {Number(movimento.importo)
                                                        .toLocaleString(
                                                            'it-IT',
                                                            {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            }
                                                        )
                                                    }

                                                </td>


                                                {/* Categoria */}
                                                <td>
                                                    {movimento.categoria}
                                                </td>


                                                {/* Classificazione */}
                                                <td>

                                                    {movimento.importoCentesimi < 0 ? (

                                                        'Uscita'

                                                    ) : movimento.tipoEntrata === 'da_identificare' ? (

                                                        <div style={{minWidth: 280}}>

                                                            {tipoEntrata === 'da_identificare' ? (

                                                                <div
                                                                    style={{
                                                                        marginBottom: 8,
                                                                        color: '#a06000'
                                                                    }}
                                                                >
                                                                    <b>Da identificare</b>
                                                                </div>

                                                            ) : (

                                                                <div
                                                                    className="text-success"
                                                                    style={{marginBottom: 8}}
                                                                >
                                                                    <b>
                                                                        {tipoEntrata === 'generica'
                                                                            ? 'Entrata generica'
                                                                            : 'Quota iscritto'
                                                                        }
                                                                    </b>
                                                                </div>

                                                            )}


                                                            {tipoEntrata !== 'generica' &&
                                                                <TendinaEditabile
                                                                    nomeCampo="COGNOME"
                                                                    nomeCampo2="NOME"
                                                                    nomeCampoParentesi="NUMERO_TESSERA"
                                                                    nomeCampoNonVisibile="ID"
                                                                    bloccoInserimento="1"

                                                                    valoreDefault={
                                                                        classificazione?.nominativo || ''
                                                                    }

                                                                    arrayValori={
                                                                        risultatoServerDatiPersona
                                                                    }

                                                                    callbackSetValoreTendEditabile={
                                                                        (
                                                                            valore,
                                                                            posizione,
                                                                            valoreNonVisibile
                                                                        ) => {

                                                                            selezionaIscrittoMovimento(
                                                                                movimento.riga,
                                                                                valore,
                                                                                valoreNonVisibile
                                                                            );

                                                                        }
                                                                    }
                                                                />
                                                            }


                                                            {tipoEntrata !== 'generica' &&
                                                                <Button
                                                                    size="sm"
                                                                    color="secondary"
                                                                    className="mt-2"
                                                                    disabled={
                                                                        loading ||
                                                                        registrazioneEseguita
                                                                    }
                                                                    onClick={() =>
                                                                        classificaEntrataGenerica(
                                                                            movimento.riga
                                                                        )
                                                                    }
                                                                >
                                                                    Entrata generica
                                                                </Button>
                                                            }


                                                            {classificazione &&
                                                                <Button
                                                                    size="sm"
                                                                    color="link"
                                                                    className="mt-2"
                                                                    disabled={
                                                                        loading ||
                                                                        registrazioneEseguita
                                                                    }
                                                                    onClick={() =>
                                                                        annullaClassificazione(
                                                                            movimento.riga
                                                                        )
                                                                    }
                                                                >
                                                                    Annulla scelta
                                                                </Button>
                                                            }


                                                            {tipoEntrata === 'quota_iscritto' &&
                                                             classificazione?.nominativo &&
                                                                <div
                                                                    style={{
                                                                        marginTop: 5,
                                                                        fontSize: '0.9em'
                                                                    }}
                                                                >
                                                                    {classificazione.nominativo}
                                                                </div>
                                                            }


                                                            {tipoEntrata === 'da_identificare' &&
                                                             movimento.riconoscimentoIscritto?.candidati?.length > 0 &&
                                                                <div
                                                                    style={{
                                                                        fontSize: '0.85em',
                                                                        marginTop: 8
                                                                    }}
                                                                >
                                                                    Candidati:{' '}

                                                                    {movimento.riconoscimentoIscritto.candidati
                                                                        .map(c =>
                                                                            `${c.nominativo} (${c.punteggio})`
                                                                        )
                                                                        .join(', ')
                                                                    }
                                                                </div>
                                                            }

                                                        </div>

                                                    ) : tipoEntrata === 'generica' ? (

                                                        <span>
                                                            Entrata generica

                                                            {movimento.motivoEntrataGenerica &&
                                                                <>
                                                                    {' ('}
                                                                    {movimento.motivoEntrataGenerica}
                                                                    {')'}
                                                                </>
                                                            }
                                                        </span>

                                                    ) : movimento.riconoscimentoIscritto?.automatico ? (

                                                        <span className="text-success">
                                                            {movimento.riconoscimentoIscritto.nominativo}
                                                        </span>

                                                    ) : (

                                                        <b>Da identificare</b>

                                                    )}

                                                </td>

                                            </tr>
                                        );

                                    })}

                                </tbody>

                            </Table>


                            {/* ------------------------------------------------------------ */}
                            {/* PULSANTI */}
                            {/* ------------------------------------------------------------ */}

                            <Button
                                color="primary"
                                disabled={
                                    numeroSelezionati === 0 ||
                                    loading ||
                                    registrazioneEseguita
                                }
                                onClick={registraMovimenti}
                            >
                                Registra {numeroSelezionati} movimenti in Prima Nota
                            </Button>

                            &nbsp;&nbsp;

                            <Button
                                color="primary"
                                disabled={loading}
                                onClick={nuovaImportazione}
                            >
                                Nuova importazione
                            </Button>

                        </>
                    }

                </CardBody>

            </div>

        </div>
    );
}

export default ImportazioneMovimentiBancari;